<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <!-- gradasi utama warna air -->
      <linearGradient :id="waterGradientId" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="#A0E9FF" />
        <stop offset="100%" stop-color="#00A3FF" />
      </linearGradient>

      <!-- highlight efek cahaya -->
      <linearGradient :id="highlightGradientId" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="white" stop-opacity="0.8" />
        <stop offset="100%" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>

    <!-- bentuk tetesan air -->
    <path
      d="M32 4C32 4 12 28 12 44C12 55.05 20.95 64 32 64C43.05 64 52 55.05 52 44C52 28 32 4 32 4Z"
      :fill="isLeakage ? `url(#${waterGradientId})` : 'none'"
      :stroke="isLeakage ? 'none' : '#9A9A9A'"
      :stroke-width="isLeakage ? '0' : '2'"
    />

    <!-- highlight di sisi kiri -->
    <path
      v-if="isLeakage"
      d="M24 18C20 26 16 34 16 42C16 50 21 56 28 58"
      :stroke="`url(#${highlightGradientId})`"
      stroke-width="4"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'WaterDropIcon',
  props: {
    size: {
      type: String,
      default: '24'
    },
    isLeakage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      uniqueId: Math.random().toString(36).substring(2, 9)
    }
  },
  computed: {
    waterGradientId () {
      return `waterGradient-${this.uniqueId}`
    },
    highlightGradientId () {
      return `highlightGradient-${this.uniqueId}`
    }
  }
}
</script>
